import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { AppMainComponent } from '../../../../app.main.component';
import { ObjectNames, Severity } from '../../constants/constants';
import { OrdersService } from '../orders.service';

@Component({
  selector: 'app-orders-type',
  templateUrl: './orders-type.component.html',
  styleUrls: ['./orders-type.component.scss']
})
export class OrdersTypeComponent implements OnInit {

  allOrderStages = [];
  allStatus = [];
  statusLists = [];
  displayEditOrderStatus = false;
  orderStageTemp = {
    "id":0,
    "name":"",
    "createdUser":"",
    "isActive":true,
    "isDefault":false,
    "children":[],
    "statusChildren":[]
  }
  orderStatusTemp = {
    "id":0,
    "name":"",
    "isActive":true,
    "isDefault":false,
    "children":[]
  }

  @Input() ordersSubmoduleTypeId: any;
  @Input() ordersSubmoduleConfig: any;
  @Input() allOrderSubmodule = [];
  sourceStatusList = [];
  targetStatusList = [];
  ordersSubmoduleStageTemp: any = {};

  constructor(
    private fb: FormBuilder,
    private app: AppMainComponent,
    private service: ConfigurationService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private orderConfigService: OrdersService,
    private titlecasePipe: TitleCasePipe
  ) { }



  ngOnInit(): void {
      //console.log("");
    // this.orderConfigService.getAllOrderStages().then(s => {
    //   this.allOrderStages = s;
    //   //console.log('allOrderStages : ', this.allOrderStages);
    // });
    // this.orderConfigService.getAllOrderStatus().then(s => {
    //   this.allStatus = s;
    // });
  }

  eventCalled(subModuleRow) {
    if (subModuleRow?.isDefault) {
      if(subModuleRow?.stages?.length > 0) {
        subModuleRow.stages[0].isDefault = true;
      }
      this.allOrderSubmodule.forEach(element => {
        if (element.id != subModuleRow.id) {
          element.isDefault = false;
          if(element?.stages?.length > 0) {
            element.stages[0].isDefault = false;
          }
        }
      });
      this.updateOrderSubmodule(subModuleRow);
    }
  }

  updateOrderSubmodule(subModuleRowData) {
    this.allOrderSubmodule.forEach(element => {
      if (subModuleRowData?.id == element?.id) {
        // if(this.displayEditParentStatus) {
        //   element.statusTypeName = subModuleRowData?.statusTypeName;
        // } else if(this.displayEditChildStatus){
        //   element.name = subModuleRowData?.name;
        // }
        element.isActive = subModuleRowData?.isActive;
        element.isDefault = subModuleRowData?.isDefault;
        element.updatedDate = new Date().toISOString();
      }
    });

    this.ordersSubmoduleConfig.configJSONValue = JSON.stringify(this.allOrderSubmodule);
    this.updateConfigurations();
  }

  updateConfigurations() {
    this.service.updateConfiguration(this.ordersSubmoduleConfig).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Sub module updated successfully...' });
      this.loadConfigurations();
    }).catch(() => {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }

  loadConfigurations() {
    this.service.getAllConfiguration().subscribe(configs => {
      this.ordersSubmoduleConfig = configs.filter(s => s.name == ObjectNames.OrdersConstants.Orders_Submodule_Object && s.typeId == this.ordersSubmoduleTypeId)[0];
      this.allOrderSubmodule = JSON.parse(this.ordersSubmoduleConfig?.configurationDetails[0]?.configJSONValue);
      // this.isInventoryChannelDisabled = false;
    });
  }

  showEditStatus(parentData, childData){
    // for(let a of s.children){
    //   this.statusLists = this.statusLists.filter(element => element.name !== a.name);
    // }
    this.ordersSubmoduleStageTemp = {
      'templateName': parentData?.name,
      'stageName': childData?.name,
      'templateId': parentData?.id,
      'stageId': childData?.id,
    };
    this.sourceStatusList = [];
    this.targetStatusList = [];
    childData.status.forEach((element, index) =>{
      if(element.isActive) {
        this.sourceStatusList.push(element);
      } else {
        this.targetStatusList.push(element);
      }
    });
    this.displayEditOrderStatus = true;
  }

  saveOrderStatus(){
    this.targetStatusList.map(statusData => statusData.isActive = false);
    this.sourceStatusList.map(statusData => statusData.isActive = true);
    this.ordersSubmoduleConfig.configJSONValue = JSON.stringify(this.allOrderSubmodule);
    this.updateConfigurations();
    this.displayEditOrderStatus = false;
  }

}
